module.exports = __webpack_public_path__ + "mainassets/img/about-us.9843d110.jpg";